module.exports = __webpack_public_path__ + "img/Lightbrown.1a0744e5.png";